// extracted by mini-css-extract-plugin
module.exports = {"list":"item_list__6kCKL","container":"item_container__jYZSA","closed":"item_closed__gzdHI"};